import { FC, PropsWithChildren, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { userStatus } from "../../api/hooks/user/user";
import routes from "../../constants/routes";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

type AuthState = "loading" | "authenticated" | "unauthenticated";

const PrivateRoute: FC<PropsWithChildren> = ({ children }) => {
  const [authState, setAuthState] = useState<AuthState>("loading");
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;

    userStatus()
      .then(() => {
        if (isMounted) {
          setAuthState("authenticated");
        }
      })
      .catch(() => {
        if (isMounted) {
          setAuthState("unauthenticated");
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  if (authState === "loading") {
    return <LoadingSpinner />;
  }

  if (authState === "unauthenticated") {
    return <Navigate to={routes.login} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
